export enum TravelChoiceEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP'
}

export const travelChoiceEnumMapping: Record<TravelChoiceEnum, string> = {
  [TravelChoiceEnum.INDIVIDUAL]: 'Voyage individuel',
  [TravelChoiceEnum.GROUP]: 'Rejoindre le groupe'
}

// English (foreign) staff join the group where the foreign provider meets it (e.g. St Pancras).
// When that place is known the GROUP label names it, otherwise the generic label is kept.
export const getTravelChoiceEnumMapping = (
  meetingPlace?: string
): Record<TravelChoiceEnum, string> => {
  if (!meetingPlace) return travelChoiceEnumMapping
  return {
    ...travelChoiceEnumMapping,
    [TravelChoiceEnum.GROUP]: `${travelChoiceEnumMapping[TravelChoiceEnum.GROUP]} à ${meetingPlace}`
  }
}
